import React, { useRef } from "react";

const CircularCategoriesSlider = ({
  categories,
  shopAllLink = "/shop-collection-sub",
}) => {
  const categoriesRef = useRef(null);

  const scrollBy = (delta) => {
    if (categoriesRef.current) {
      categoriesRef.current.scrollBy({
        left: delta,
        behavior: "smooth",
      });
    }
  };
  return (
    <>
      <style>
        {`

        
          /* تصغير ارتفاع العنصر الدائري */
          #circularCategoriesSlider-section .collection-item-circle .collection-image.img-style {
            width: 85px !important;
            height: 85px !important;
            min-width: 85px !important;
            min-height: 85px !important;
            max-width: 85px !important;
            max-height: 85px !important;
            border-radius: 50% !important;
            object-fit: cover;
            margin: 0 auto 2px auto !important;
            box-shadow: 0 2px 8px rgba(0,0,0,0.07);
            transition: box-shadow 0.2s;
          }
            

          /* تصغير ارتفاع الكونتينت تحت الصورة */
          .collection-item-circle .collection-content {
            min-height: 28px !important;
            padding: 0 !important;
            margin-top: 0 !important;
            margin-bottom: 0 !important;
          }

          /* زيادة عدد العناصر الظاهرة في السطر الواحد */
          @media (min-width: 1200px) {
            .tf-categories-container .collection-item-circle {
              flex: 0 0 calc(100% / 14) !important;
              max-width: calc(100% / 14) !important;
            }
          }
          /* Cool styling for category text */
          .collection-item-circle .collection-content .title {
            background: none !important;
            -webkit-background-clip: unset !important;
            -webkit-text-fill-color: unset !important;
            background-clip: unset !important;
            color: #0e5aa7 !important;
            font-family: 'Inter', 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;
            font-weight: 800 !important;
            font-size: 15px !important;
            letter-spacing: 0.5px !important;
            text-transform: uppercase;
            transition: all 0.3s ease;
            text-shadow: none !important;
            animation: none !important;
            position: relative;
            font-feature-settings: 'kern' 1, 'liga' 1, 'calt' 1;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            margin-top: 0 !important;
            margin-bottom: 0 !important;
            line-height: 1.2 !important;
          }

          .collection-item-circle:hover .collection-content .title {
            transform: translateY(-2px);
            filter: brightness(1.1);
            color: #0e5aa7 !important;
          }

          @keyframes gradientShift {
            0%, 100% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
          }

          /* Shop all button special styling */
          .tf-shopall .collection-content .title {
            background: none !important;
            -webkit-background-clip: unset !important;
            -webkit-text-fill-color: unset !important;
            background-clip: unset !important;
            color: #0e5aa7 !important;
            font-family: 'Inter', 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;
            font-weight: 800 !important;
            animation: none !important;
            font-feature-settings: 'kern' 1, 'liga' 1, 'calt' 1;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
          }

          @keyframes shopAllGradient {
            0%, 100% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
          }

          .tf-shopall:hover .collection-content .title {
            background: none !important;
            -webkit-background-clip: unset !important;
            -webkit-text-fill-color: unset !important;
            background-clip: unset !important;
            color: #0e5aa7 !important;
            animation: none !important;
          }

          /* Add subtle glow effect */
          .collection-item-circle .collection-content {
            position: relative;
          }

          .collection-item-circle .collection-content::before {
            content: '';
            position: absolute;
            top: -5px;
            left: 50%;
            transform: translateX(-50%);
            width: 0;
            height: 2px;
            background: linear-gradient(90deg, transparent, #0e5aa7, transparent);
            transition: width 0.3s ease;
          }

          .collection-item-circle:hover .collection-content::before {
            width: 80%;
          }

          /* Reduce horizontal spacing in original slider layout */
          .tf-categories-container .collection-item-circle {
            margin-right: -20px !important;
            margin-left: 0 !important;
            margin-bottom: 0 !important;
            margin-top: 0 !important;
            padding-bottom: 0 !important;
          }

          .tf-categories-container .collection-item-circle:last-child {
            margin-right: 0 !important;
          }

          /* Reduce section spacing and horizontal padding */
          .flat-spacing-20 {
            padding: 20px 0 0px 0 !important;
            margin: 0 !important;
            margin-bottom: 0 !important;
            padding-bottom: 0px !important;
          }

          #circularCategoriesSlider-section {
            max-width: 1600px !important;
            margin: 0 auto !important;
            margin-bottom: 0 !important;
            padding-left: 20px !important;
            padding-right: 20px !important;
            padding-bottom: 0 !important;
            box-sizing: border-box !important;
            overflow: visible !important;
          }

          .flat-spacing-20 .container {
            padding-left: 5px !important;
            padding-right: 5px !important;
            padding-bottom: 0 !important;
            margin-bottom: 0 !important;
            max-width: 75%;
            margin: 0 auto;
            margin-top: 0 !important;
            padding-top: 0 !important;
          }

       .tf-categories-wrap {
  display: flex !important;
  align-items: center;
  justify-content: flex-start;
  gap: 0px;
  padding-left: 60px !important;
  padding-right: 60px !important;
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
  margin-top: 0 !important;
  padding-top: 0 !important;
  position: relative;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  overflow: visible !important;
}

#circularCategoriesSlider-section .container {
  overflow: visible !important;
  position: relative;
}

/* Responsive adjustments for tf-categories-wrap */
@media (max-width: 575px) {
  #circularCategoriesSlider-section {
    max-width: 100% !important;
    padding-left: 12px !important;
    padding-right: 12px !important;
  }
  .flat-spacing-20 .container {
    max-width: 90%;
  }
  .tf-categories-wrap {
    padding-left: 1px !important;
    padding-right: 1px !important;
    gap: 0px;
  }
}

@media (min-width: 576px) and (max-width: 767px) {
  #circularCategoriesSlider-section {
    max-width: 100% !important;
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
  .flat-spacing-20 .container {
    max-width: 82%;
  }
  .tf-categories-wrap {
    padding-left: 2px !important;
    padding-right: 2px !important;
    gap: 0px;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  #circularCategoriesSlider-section {
    max-width: 1200px !important;
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
  .flat-spacing-20 .container {
    max-width: 80%;
  }
  .tf-categories-wrap {
    padding-left: 4px !important;
    padding-right: 4px !important;
    gap: 0px;
  }
}

@media (min-width: 992px) and (max-width: 1199px) {
  #circularCategoriesSlider-section {
    max-width: 1400px !important;
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
  .flat-spacing-20 .container {
    max-width: 78%;
  }
  .tf-categories-wrap {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
}

@media (min-width: 1400px) {
  #circularCategoriesSlider-section {
    max-width: 1600px !important;
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
}

@media (min-width: 1200px) {
  .flat-spacing-20 .container {
    max-width: 75%;
  }
  .tf-categories-wrap {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
}

/* أزرار السهم يمين/شمال */
.home-categories-nav {
  position: absolute;
  top: 50px;
  transform: translateY(-50%);
  z-index: 100 !important;
  cursor: pointer;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.home-categories-nav-left { 
  left: -50px; 
}

.home-categories-nav-right { 
  right: -50px; 
}

.home-categories-nav .icon {
  font-size: 16px;
  color: #000 !important;
}

.home-categories-nav:hover {
  background-color: #0e5aa7;
  box-shadow: 0 4px 12px rgba(14, 90, 167, 0.4);
  transform: translateY(-50%) scale(1.1);
  border-color: #0e5aa7;
}

.home-categories-nav:hover .icon {
  color: #fff !important;
}

/* Responsive arrow positioning for smaller screens */
@media (max-width: 575px) {
  .home-categories-nav-left { 
    left: -10px !important; 
  }
  
  .home-categories-nav-right { 
    right: -10px !important; 
  }
  
  .home-categories-nav {
    width: 32px !important;
    height: 32px !important;
  }
  
  .home-categories-nav .icon {
    font-size: 14px !important;
    color: #000 !important;
  }
  
  .home-categories-nav:hover .icon {
    color: #fff !important;
  }
}

@media (min-width: 576px) and (max-width: 767px) {
  .home-categories-nav-left { 
    left: -20px !important; 
  }
  
  .home-categories-nav-right { 
    right: -20px !important; 
  }
  
  .home-categories-nav {
    width: 34px !important;
    height: 34px !important;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .home-categories-nav-left { 
    left: -30px !important; 
  }
  
  .home-categories-nav-right { 
    right: -30px !important; 
  }
}

@media (min-width: 992px) and (max-width: 1199px) {
  .home-categories-nav-left { 
    left: -40px !important; 
  }
  
  .home-categories-nav-right { 
    right: -40px !important; 
  }
}


          /* Reduce spacing between categories and shop all */
          .tf-shopall-wrap {
            margin-top: 4px !important;
            margin-bottom: 0 !important;
            padding-bottom: 0 !important;
            padding-top: 0 !important;
          }
            /* خلى الكونتينر يسكروول ناعم */
.tf-categories-container {
  scroll-behavior: smooth;
}

/* على الشاشات الكبيرة خلى كل آيتم ياخد 1/12 من العرض */
@media (min-width: 1200px) {
  .tf-categories-container .collection-item-circle {
    flex: 0 0 calc(100% / 12) !important;
    max-width: calc(100% / 12) !important;
  }
}

/* Duplicate .tf-categories-wrap removed - responsive rules are defined above */

        `}
      </style>
      <section
        id="circularCategoriesSlider-section"
        className="flat-spacing-20"
        style={{ marginBottom: "0px", paddingBottom: "0px" }}
      >
        <div className="container">
          <div className="tf-categories-wrap no-scrollbar circularCategoriesSlider-tf-categories-wrap">
            <div
              id="categories-container"
              ref={categoriesRef}
              className="tf-categories-container circularCategoriesSlider-tf-categories-container  no-scrollbar"
            >
              {categories.map((category, index) => (
                <div
                  key={index}
                  className="collection-item-circle collection-item-circle-header hover-img"
                >
                  <a
                    href={category.link || "/shop-collection-sub"}
                    className="collection-image img-style"
                  >
                    <img
                      data-src={category.image}
                      src={category.image}
                      alt={category.name}
                      className="lazyload"
                    />
                  </a>
                  <div className="collection-content text-center collection-content-before">
                    <a
                      href={category.link || "/shop-collection-sub"}
                      className="link title fw-6"
                    >
                      {category.name}
                    </a>
                  </div>
                </div>
              ))}
            </div>

            <button
              type="button"
              className="home-categories-nav home-categories-nav-left box-icon round"
              onClick={() => scrollBy(-250)}
              aria-label="Scroll categories left"
            >
              <span className="icon icon-arrow-left"></span>
            </button>

            <button
              type="button"
              className="home-categories-nav home-categories-nav-right box-icon round"
              onClick={() => scrollBy(250)}
              aria-label="Scroll categories right"
            >
              <span className="icon icon-arrow-right"></span>
            </button>

            <div className="tf-shopall-wrap">
              <div className="collection-item-circle tf-shopall">
                <a
                  href={shopAllLink}
                  className="collection-image img-style tf-shopall-icon"
                >
                  <i className="icon icon-arrow1-top-left"></i>
                </a>
                <div className="collection-content text-center collection-content-before">
                  <a href={shopAllLink} className="link title fw-6">
                    Shop all
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CircularCategoriesSlider;
